import {
  Root as SwitchRoot,
  Thumb as SwitchThumb,
} from "@radix-ui/react-switch";
import "./styles.css";

const Toggle = ({ label, checked, onCheckedChange }) => (
  <div style={{ display: "flex", alignItems: "center" }}>
    {label && (
      <label
        className="Label"
        htmlFor="airplane-mode"
        style={{ paddingRight: 15 }}
      >
        Airplane mode
      </label>
    )}
    <SwitchRoot
      checked={checked}
      onCheckedChange={onCheckedChange}
      className="SwitchRoot bg-violet-600/20"
    >
      <SwitchThumb className="SwitchThumb" />
    </SwitchRoot>
  </div>
);

export default Toggle;
